<template>
    <a-layout class="main-layout">
        <LayoutHeader />
        <a-layout-content class="main-content">
            <router-view></router-view>
        </a-layout-content>
        <LayoutFooter />
    </a-layout>
</template>

<script>
import LayoutHeader from './Header.vue'
import LayoutFooter from './Footer.vue'

export default {
    name: 'MainLayout',
    components: {
        LayoutHeader,
        LayoutFooter
    }
}
</script>

<style lang="scss" scoped>
.main-layout {
    min-height: 100vh;

    .main-content {
        margin-top: 64px; // Header height
        min-height: calc(100vh - 64px - 400px); // 100vh - header - footer
        background: #ffffff;
    }
}
</style>
